import { render, staticRenderFns } from "./ModalDesign.vue?vue&type=template&id=2ed35f91&scoped=true&"
import script from "./ModalDesign.vue?vue&type=script&lang=js&"
export * from "./ModalDesign.vue?vue&type=script&lang=js&"
import style0 from "./ModalDesign.vue?vue&type=style&index=0&id=2ed35f91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed35f91",
  null
  
)

export default component.exports